// react
import React, { useEffect, useState } from "react";
// style
import "./Circuit.css"

const Circuit = (props) => {

	const [isShown, setIsShown] = useState(false);

	const [icon, setIcon] = useState("")
	const [icons, setIcons] = useState([])
	const [positionLandscape, setPositionLandscape] = useState({left:0, top:0})
	const [positionPortrait, setPositionPortrait] = useState({left:0, top:0})
	const [titleposition, setTitleposition] = useState({left:0, top:0, direction:""})
	const [name, setName] = useState("")

	useEffect(() => {
		//console.log(props.id === props.menu)
		if(props.content){
			for(let s of props.content.sections){
				if(s.id === props.id){
					setIcon(s.img)
					setPositionLandscape({
						top:s.position.landscape.top,
						left:s.position.landscape.left
					})
					setPositionPortrait({
						top:s.position.portrait.top,
						left:s.position.portrait.left
					})
					setName(s.name[props.lang])

					if(s.hasOwnProperty("titleposition")){
						if(s.titleposition.hasOwnProperty("direction")){
							if(s.titleposition.direction === "right"){
								setTitleposition({
									top:s.titleposition.top,
									right:s.titleposition.left
								})
							}else{
								setTitleposition({
									top:s.titleposition.top,
									left:s.titleposition.left
								})
							}
						}else{
							setTitleposition({
								top:s.titleposition.top,
								left:s.titleposition.left
							})
						}
					}
				}
			}
			let iconsTemp = []
			for(let p of props.content.products){
				if(p.section === props.id){
					iconsTemp.push(p)
				}
			}
			setIcons(iconsTemp)
		}
		
	}, [props.content, props.lang])

	return (
		<React.Fragment>

			{/* main icon */}
			<div
				className={"icon icon-horizontal"}
				style={positionLandscape}
			>
				<div
					className={"icon-bg "+(props.id === props.menu ? "icon-bg-selected" : "")+""}
					style={{
						//backgroundImage:"url('"+icon+"')"
					}}
					onClick={() => props.toggle(props.id)}
					onMouseEnter={() => setIsShown(true)}
        			onMouseLeave={() => setIsShown(false)}
				></div>
			</div>
			<div
				className={"icon icon-vertical"}
				style={positionPortrait}
			>
				<div
					className={"icon-bg "+(props.id === props.menu ? "icon-bg-selected" : "")+""}
					style={{
						//backgroundImage:"url('"+icon+"')"
					}}
					onClick={() => props.toggle(props.id)}
					onMouseEnter={() => setIsShown(true)}
        			onMouseLeave={() => setIsShown(false)}
				></div>
			</div>

			{/* child icons */}
			{icons.map(i => (
				<React.Fragment>
					<div
						key={i.id}
						className={"icon icon-horizontal"}
						style={{
							top:i.position.landscape && i.position.landscape.top,
							left:i.position.landscape && i.position.landscape.left,
							opacity: props.menu === i.section ? 1 : 0,
							pointerEvents: props.menu === i.section ? "auto" : "none"
						}}
					>
						<div
							className={"icon-bg icon-small circuit-hover"}
							style={{
								//backgroundImage:"url('"+i.icon+"')"
							}}
							onClick={() => props.popup(i.id)}
						>
							<div
								className={"icon-title tsv5 "+(i.hasOwnProperty("nameposition") && i.nameposition === "right" ? "icon-title-right" : "")+""}
							><p>{i.name[props.lang]}</p></div>
						</div>
					</div>
					<div
						key={i.id}
						className={"icon icon-vertical"}
						style={{
							top:i.position.portrait && i.position.portrait.top,
							left:i.position.portrait && i.position.portrait.left,
							opacity: props.menu === i.section ? 1 : 0,
							pointerEvents: props.menu === i.section ? "auto" : "none"
						}}
					>
						<div
							className={"icon-bg icon-small circuit-hover"}
							style={{
								//backgroundImage:"url('"+i.icon+"')"
							}}
							onClick={() => props.popup(i.id)}
						>
							<div
								className={"icon-title tsv5 "+(i.hasOwnProperty("nameposition") && i.nameposition === "right" ? "icon-title-right" : "")+""}
							><p>{i.name[props.lang]}</p></div>
						</div>
					</div>
				</React.Fragment>
			))}

			{/* circuit deploy */}
			<div
				className={"circuit circuit-deploy-"+props.id+" "+(props.id === props.menu ? "" : "")+""}
				style={{ opacity: props.id === props.menu ? 1 : 0 }}
			></div>

			{/* circuit title */}
			<div
				className={"circuit circuit-title-"+props.id+" "+(props.id === props.menu ? "" : "")+""}
				style={{ opacity: (props.id === props.menu || isShown) ? 1 : 0 }}
			>
				<div
					className="circuit-title tsv5"
					style={titleposition}
				>{name}</div>
			</div>
		</React.Fragment>
	)
}

export default Circuit;